import React, { useState } from 'react';
import { BuildingIcon, PenToolIcon, RefreshCwIcon, ClipboardListIcon, HomeIcon, KeyIcon, WrenchIcon, CompassIcon } from 'lucide-react';
import Button from '../components/ui/Button';
// Detailed service descriptions
const serviceDescriptions = [{
  id: 'construction',
  title: 'Construction Services',
  icon: <BuildingIcon size={40} data-id="element-664" />,
  description: 'Quality work at Socrates & Richard Company Limited is accomplished through careful planning, dedication, skilled and superior execution by our well trained and experienced team. We are committed to building high quality projects no matter what the size or scope is, it will stand out for generations to come.'
}, {
  id: 'design',
  title: 'Design & Building Services',
  icon: <PenToolIcon size={40} data-id="element-665" />,
  description: 'Design and Building is one of the most proficient and important part of our construction company. We have a duty as a construction company to deliver accurate, perfect designs and building services as we are viewed based on our services provided in the industry. We have developed significant relationship with clients, engineering firms and other contractors to address design and constructing issues, allowing all parties to enjoy the benefits from the design building process.'
}, {
  id: 'rehabilitation',
  title: 'Rehabilitation & Renovation Services',
  icon: <RefreshCwIcon size={40} data-id="element-666" />,
  description: "Our Company has been privileged to work in some of the most beautiful areas of the country. Maintaining and protecting a healthy environment and properties is essential to us and also to those who use them for recreational purposes. We are thereby committed to protecting the environment by carefully planning of our work with the goal of sustainable environment in mind and the use of best management practices in the field. We are also able to refurbish properties to meet with client's ambience impression and expectations."
}, {
  id: 'project',
  title: 'Project Management',
  icon: <ClipboardListIcon size={40} data-id="element-667" />,
  description: 'We ensure the success of projects from the scoping and programming stages all the way through design, construction, commission, close out (commissioning) and moving in. Each project is carefully designed and planned for execution and a successful outcome that meets the project goals. Also we offer continuous, uninterrupted coverage for maintenance and management responsibilities for building facilities.'
}, {
  id: 'property',
  title: 'Property Development',
  icon: <HomeIcon size={40} data-id="element-668" />,
  description: 'As the industry increasingly shifts towards the provision of more specialist services demanded by customers, our goal is to within the best of our capacity, to continuously provide our clients with their required specifications. This also includes sales or lease of funded properties on completion. Examples are office-building, warehouses etc.'
}, {
  id: 'real-estate',
  title: 'Real Estate Services',
  icon: <KeyIcon size={40} data-id="element-669" />,
  description: "Our Company works with commercial and residential builders, real estate and subsidized housing developers, owners and operators, heavy construction companies, specialty engineers and federal government contractors to meet and exceed client's expectations."
}, {
  id: 'management',
  title: 'Property Management Services',
  icon: <WrenchIcon size={40} data-id="element-670" />,
  description: 'We offer continuous, uninterrupted coverage for maintenance and management responsibilities for building facilities. We provide all necessary labour, materials, equipment and support to ensure the successful implementation of all requirements listed in our agreements. This is done through our enabled site representatives and on-site management. We also provide professional services for management design and construction.'
}, {
  id: 'engineering',
  title: 'General Engineering Services',
  icon: <CompassIcon size={40} data-id="element-671" />,
  description: 'Specialized and well-trained engineers are there to help, guide, and oversee our construction project. To supervise, design and to make sure the construction activities are going well. This also includes construction of roads, bridges, pipeline installation, sewage systems, railway roads and others. With the cooperation of the workers, we deliver the best we can as we provide all necessary labor, material, equipments and support to ensure the success of our agreement.'
}];
const Services = () => {
  const [activeService, setActiveService] = useState('construction');
  return <div className="w-full pt-20 bg-gray-50" data-id="element-672">
      {/* Hero Section */}
      <section className="relative py-20 bg-[#1a2e1a]" data-id="element-673">
        <div className="absolute inset-0 z-0 opacity-30" data-id="element-674">
          <img src="https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Construction services" className="w-full h-full object-cover" data-id="element-675" />
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-676">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-677">
            Our Services
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-678">
            Comprehensive construction and engineering solutions delivered with
            excellence
          </p>
        </div>
      </section>
      {/* Services Section */}
      <section className="py-20" data-id="element-679">
        <div className="container mx-auto px-4 md:px-6" data-id="element-680">
          <div className="text-center mb-12" data-id="element-681">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2e1a] mb-4" data-id="element-682">
              What We Offer
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-683">
              Explore our comprehensive range of services designed to meet all
              your construction and engineering needs
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-6 mb-12" data-id="element-684">
            {/* Service Navigation */}
            <div className="md:col-span-1 bg-white rounded-lg shadow-md p-4" data-id="element-685">
              <h3 className="text-lg font-bold text-[#1a2e1a] mb-4 pb-2 border-b border-gray-200" data-id="element-686">
                Our Services
              </h3>
              <ul className="space-y-2" data-id="element-687">
                {serviceDescriptions.map(service => <li key={service.id} data-id="element-688">
                    <button onClick={() => setActiveService(service.id)} className={`w-full text-left px-4 py-2 rounded-md transition-colors ${activeService === service.id ? 'bg-[#95c11f] text-white font-medium' : 'hover:bg-gray-100 text-gray-700'}`} data-id="element-689">
                      {service.title}
                    </button>
                  </li>)}
              </ul>
            </div>
            {/* Service Details */}
            <div className="md:col-span-3" data-id="element-690">
              {serviceDescriptions.map(service => <div key={service.id} className={`bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 ${activeService === service.id ? 'opacity-100' : 'hidden'}`} data-id="element-691">
                  <div className="flex items-center bg-[#1a2e1a] p-6" data-id="element-692">
                    <div className="bg-white rounded-full p-3 mr-4 text-[#95c11f]" data-id="element-693">
                      {service.icon}
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-694">
                      {service.title}
                    </h3>
                  </div>
                  <div className="p-6" data-id="element-695">
                    <p className="text-gray-700 leading-relaxed" data-id="element-696">
                      {service.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>
      {/* Approach Section */}
      <section className="py-20 bg-white" data-id="element-697">
        <div className="container mx-auto px-4 md:px-6" data-id="element-698">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-699">
            <div data-id="element-700">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a2e1a] mb-6" data-id="element-701">
                Our Approach
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-702">
                At Socrates and Richard Company, we follow a systematic approach
                to ensure every project is delivered to the highest standards of
                quality and client satisfaction.
              </p>
              <div className="space-y-6" data-id="element-703">
                <div className="flex" data-id="element-704">
                  <div className="flex-shrink-0 mr-4" data-id="element-705">
                    <div className="bg-[#95c11f] text-white rounded-full w-10 h-10 flex items-center justify-center font-bold" data-id="element-706">
                      1
                    </div>
                  </div>
                  <div data-id="element-707">
                    <h3 className="text-xl font-bold text-[#1a2e1a] mb-2" data-id="element-708">
                      Consultation & Planning
                    </h3>
                    <p className="text-gray-700" data-id="element-709">
                      We begin with a thorough consultation to understand your
                      needs and objectives, followed by detailed planning and
                      feasibility assessment.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-710">
                  <div className="flex-shrink-0 mr-4" data-id="element-711">
                    <div className="bg-[#95c11f] text-white rounded-full w-10 h-10 flex items-center justify-center font-bold" data-id="element-712">
                      2
                    </div>
                  </div>
                  <div data-id="element-713">
                    <h3 className="text-xl font-bold text-[#1a2e1a] mb-2" data-id="element-714">
                      Design & Engineering
                    </h3>
                    <p className="text-gray-700" data-id="element-715">
                      Our expert team develops comprehensive designs and
                      engineering solutions tailored to your specific
                      requirements and constraints.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-716">
                  <div className="flex-shrink-0 mr-4" data-id="element-717">
                    <div className="bg-[#95c11f] text-white rounded-full w-10 h-10 flex items-center justify-center font-bold" data-id="element-718">
                      3
                    </div>
                  </div>
                  <div data-id="element-719">
                    <h3 className="text-xl font-bold text-[#1a2e1a] mb-2" data-id="element-720">
                      Implementation & Construction
                    </h3>
                    <p className="text-gray-700" data-id="element-721">
                      We execute with precision, adhering to strict quality
                      control measures and maintaining clear communication
                      throughout the process.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-722">
                  <div className="flex-shrink-0 mr-4" data-id="element-723">
                    <div className="bg-[#95c11f] text-white rounded-full w-10 h-10 flex items-center justify-center font-bold" data-id="element-724">
                      4
                    </div>
                  </div>
                  <div data-id="element-725">
                    <h3 className="text-xl font-bold text-[#1a2e1a] mb-2" data-id="element-726">
                      Quality Assurance & Handover
                    </h3>
                    <p className="text-gray-700" data-id="element-727">
                      Final inspections ensure everything meets our high
                      standards before project handover, followed by dedicated
                      after-service support.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-728">
              <img src="https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Project planning" className="rounded-lg shadow-xl w-full" data-id="element-729" />
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 bg-[#1a2e1a] relative overflow-hidden" data-id="element-730">
        <div className="absolute inset-0 opacity-10" data-id="element-731">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" data-id="element-732">
            <pattern id="pattern-service" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-733">
              <circle cx="1" cy="1" r="1" fill="white" data-id="element-734" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#pattern-service)" data-id="element-735" />
          </svg>
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-736">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-737">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-738">
            Contact us today to discuss how we can bring your vision to life
            with our expert services and dedicated team.
          </p>
          <Button to="/contact" variant="primary" size="lg" data-id="element-739">
            Request a Consultation
          </Button>
        </div>
      </section>
    </div>;
};
export default Services;